import html2canvas from "html2canvas";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { formatDateTime } from "./Date";
import { Grid } from "@material-ui/core";
import { toPng } from "html-to-image";
import jsPDF from "jspdf";
import QRCode from "qrcode";
import html2pdf from "html2pdf.js";
import { IoMdDownload } from "react-icons/io";

const InvitationCard = ({ event, download, view, modalCloseRef }) => {
  // console.log(event);
  // return

  const ref = React.useRef(null);
  const [showPasss, setShowPass] = useState(false);
  const [showQrButtons, setShowQrButtons] = React.useState(false);
  const submitButtonRef = useRef(null);
  const [qr, setQr] = useState("");

  const GenerateQRCode = () => {
    QRCode.toDataURL(
      event?.data?.mobileNumber,
      {
        width: 240,
        margin: 1,
        // color: {
        // 	dark: '#335383FF',
        // 	light: '#EEEEEEFF'
        // }
      },
      (err, url) => {
        if (err) return console.error(err);

        // console.log(url);
        setQr(url);
      },
    );
  };
  useEffect(() => {
    GenerateQRCode();
  }, [event]);

  const containerStyle = {
    maxWidth: "380px",
    backgroundColor: "#f4f4f4",
    margin: "0 auto", // Center horizontally
    display: "flex",
    justifyContent: "center", // Center horizontally
    alignItems: "center", // Center vertically
    // height: "100vh",
  };

  const eventDetails = {
    "6979bfdaa58d37c429b2866f": {
      date: "Friday 30 January 2026",
      image: "/0.png",
      name: "मैं हू भारत",
      download: "30_Jan_Entry_pass.pdf",
      color:
        "linear-gradient(135deg, #DF9D23 0%, #EBB553 35%, #DE9CAA 70%, #F9E5D2 100%)",
    },
    "6979bff0a58d37c429b28670": {
      date: "Saturday 31 January 2026",
      image: "/1.png",
      // image: "/Dec14.jpg",
      name: "अपने अपने राम",
      download: "31_Jan_Entry_pass.pdf",
      color:
        "radial-gradient(circle at center, rgba(255, 165, 0, 0.3) 0%, transparent 50%), linear-gradient(90deg, #FFA500, #FF8C00, #FF4500)",
    },
    "6979c000a58d37c429b28671": {
      date: "Sunday 1 February 2026",
      // image: "/Dec15.jpg",
      image: "/1.png",
      name: "अपने अपने राम",
      download: "1_Feb_Entry_pass.pdf",
      color:
        "radial-gradient(circle at center, rgba(128, 0, 255, 0.3) 0%, transparent 50%), linear-gradient(90deg, #9b59b6, #8e44ad, #6c3483)",
    },
  };
  const selectedEventDetails = eventDetails[event?.data?.eventId] || {};

  const handleDownload = () => {
    const element = ref.current;
    if (!element) {
      console.error("Ref is null");
      return;
    }

    // Calculate the height based on the aspect ratio and desired width
    const aspectRatio = element.offsetHeight / element.offsetWidth;
    const pdfHeight = Math.ceil(380 * aspectRatio);

    const options = {
      margin: 0,
      filename: selectedEventDetails.download,
      image: { type: "png", quality: 1 },
      html2canvas: {
        scale: 2, // Adjust scaling as needed
        width: 380, // Set the desired width
        height: pdfHeight, // Set the calculated height
        useCORS: true,
      },
      jsPDF: {
        unit: "px",
        format: [380, pdfHeight],
        orientation: "portrait",
      },
    };

    html2pdf().set(options).from(element).save();
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      handleDownload();
    }, 2000); // 5000 milliseconds = 5 seconds

    // Cleanup the timer on component unmount
    return () => clearTimeout(timer);
  }, [event]);

  const handleViewClick = () => {
    setShowPass(true);
    setTimeout(() => {
      submitButtonRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }, 100);
  };
  // orange

  const boxLeftStyle = {
    // background: "linear-gradient(180deg, #3e1d0a, #ff147a)",
    background: selectedEventDetails.color,
    border: "1px solid #7e4104",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    borderRadius: "10px",
    width: "100%", // Make the box take full width inside the container
    maxWidth: "380px", // Set a max width for responsiveness
    // padding: "10px",
    boxSizing: "border-box", // Include padding in width/height calculation
  };

  // const headerStyle = {
  // fontFamily: "'Arya', sans-serif",
  // color: "#ffd700",
  // fontSize: "clamp(30px, 4vw, 35px)", // Responsive font size
  // textAlign: "center",
  // fontWeight: "bold",
  // marginTop: "20px",
  // // margin: 0,
  // // padding: 0,
  // lineHeight: "0.8",
  // // display: 'flex',
  // alignItems: "center",
  // };
  const headerStyle = {
    fontFamily: "'Arya', sans-serif",
    color: "#ffd700",
    textAlign: "center",
    fontWeight: "bold",
    marginTop: "0px", // Ensures no extra space at the top
    lineHeight: "0.8",
    alignItems: "center",
  };
  const logoStyle = {
    width: "170px", // Adjust the size of the logo as needed
    height: "auto",
    margin: "0 auto", // Center the logo
    display: "block", // Ensure it's block-level for proper centering
    marginBottom: "0", // Set the bottom margin to zero
  };

  const headerInviStyle = {
    fontFamily: "'Arya', sans-serif",
    color: "#fff",
    fontSize: "clamp(45px, 9vw, 50px)", // Responsive font size
    textAlign: "center",
    fontWeight: "bold",
    margin: "0", // Removes any margin above and below the text
    padding: "0", // Removes any padding if present
    lineHeight: "1", // Sets the line height to a standard value
  };
  const detailsStyle = {
    // backgroundColor: "#e6df86",
    borderRadius: "6px",
    padding: "10px",
    textAlign: "center",
    fontSize: "clamp(14px, 3vw, 20px)", // Responsive font size
    lineHeight: "1.6",
    fontWeight: "bolder",
    color: "#1d348c",
  };
  // const textStyle = {
  //   fontFamily: "'Arya', sans-serif",
  //   fontSize: "clamp(28px, 5vw, 44px)", // Values should be strings
  //   fontWeight: "bold",
  //   textAlign: "center",
  //   background: "linear-gradient(to bottom, #ff9933, #ffffff, #008000)",
  //   WebkitBackgroundClip: "text", // Use camelCase for vendor prefixes
  //   WebkitTextFillColor: "transparent", // Correct camelCase for -webkit-text-fill-color
  //   // textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)', // Shadow effect
  //   marginTop: "2vh",
  // };

  const textJubinStyle = {
    fontFamily: "'Arya', sans-serif",
    fontSize: "clamp(40px, 7vw, 50px)", // Responsive font size
    fontWeight: "900", // Extra bold
    textAlign: "center",
    color: "#F0F0F0", // Use a lighter shade of silver/white for more brightness
    // textShadow:
    //   "0 0 15px rgba(255, 255, 255, 0.8), 0 0 25px rgba(255, 255, 255, 0.7), 0 0 50px rgba(255, 255, 255, 0.5)", // Stronger glow effect for more brightness
    marginTop: "2vh",
    background: "transparent", // No gradient background to keep things simple
  };

  const imageStyle = {
    position: "absolute",
    top: "10px",
    right: "4px",
    width: "80px",
    height: "auto",
    borderRadius: "8px",
  };
  // const logoStyle = {
  //   position: "absolute",
  //   top: "10px",
  //   left: "2px",
  //   width: "80px",
  //   height: "auto",
  //   // borderRadius: '8px',
  // };

  const guestNameStyle = {
    fontFamily: "'Arial', sans-serif",
    fontSize: "16px",
    color: "white",
    fontWeight: "normal",
    marginLeft: "10px",
    marginTop: "1vh",
  };

  const qrCodeContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
    // marginTop: "10px",
    // borderTop: "2px dotted #ddd",
    borderBottom: "2px dotted #ddd",
  };

  return (
    <>
      <div className="button-container">
        {/* <button onClick={handleViewClick} className="btn-view">
          <span className="thumbnail-icon">🔍</span> {view}
        </button> */}
        <button
          // icon={<IoMdDownload />}
          ref={modalCloseRef}
          onClick={() => {
            setShowPass(true);
            handleDownload();
            // setShowForm(false);
          }}
          // onClick={handleDownload}
          className="btn-view"
        >
          <IoMdDownload />
          {download}
        </button>
      </div>

      <style jsx>{`
        .button-container {
          display: flex;
          justify-content: center;
          gap: 15px;
          margin: 20px;
        }

        .btn-download,
        .btn-view,
        .btn-views {
          padding: 12px 20px;
          font-size: 20px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          transition:
            background-color 0.3s ease,
            transform 0.2s ease-in-out;
          font-weight: 600;
          width: auto;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .btn-download {
          background: linear-gradient(
            135deg,
            #ff7f32,
            #03045e
          ); /* Mixed gradient color */
          color: white;
        }

        .btn-view {
          background: linear-gradient(
            135deg,
            #4c6ef5,
            #2a4f9c
          ); /* Stronger blue gradient */
          color: white;
          position: relative;
        }

        .btn-views {
          background: linear-gradient(
            135deg,
            #f39c12,
            #d35400
          ); /* Golden Yellow to Dark Goldenrod */
          color: white;
          position: relative;
        }

        .thumbnail-icon {
          font-size: 18px;
          margin-right: 8px;
        }

        /* Hover effects */
        .btn-download:hover {
          background: linear-gradient(135deg, #f3a6d7, #ff7f32);
          transform: scale(1.05);
        }

        .btn-view:hover {
          background: linear-gradient(135deg, #7da4c3, #a3c7e1);
          transform: scale(1.05);
        }

        /* Focus and active states */
        .btn-download:focus,
        .btn-view:focus {
          outline: none;
          box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.5);
        }

        .btn-download:active,
        .btn-view:active {
          transform: scale(0.98);
        }
      `}</style>

      {/* {showPasss && ( */}
      <div style={containerStyle}>
        <div style={boxLeftStyle} ref={ref}>
          <div>
            <div style={headerStyle}>
              <img
                src="/image.png"
                alt="khasdar"
                style={logoStyle}
                crossOrigin="anonymous"
              />
              <div style={headerInviStyle}>Entry Pass</div>
            </div>
            {/* <div style={headerStyle}>
              <span style={{ margin: 0, padding: 0 }}>Invitation</span>
              <br />
              <span
                style={{
                  color: "white",
                  fontSize: "20px",
                  margin: 0,
                  padding: 0,
                  lineHeight: "1",
                }}
              >
              </span>
            </div>
            <div style={textStyle}>Crescendo</div>
            <img
              src="/bharatOnline.png"
              alt="Image"
              style={imageStyle}
              crossOrigin="anonymous"
            />
            <img
              src="/image.png"
              alt="khasdar"
              style={logoStyle}
              crossOrigin="anonymous"
            /> */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={guestNameStyle}>
                <span style={{ fontSize: "25px", fontWeight: "bold" }}>
                  Name: {event?.data?.firstName}
                </span>
                <br />
                <span>Mobile No: {event?.data?.mobileNumber}</span>
                <br />
                <span>
                  Registration Date: {formatDateTime(event?.data?.createdAt)}
                </span>
              </div>
            </div>

            {/* <div style={guestNameStyle}>
                <span>श्री./सौ. {event?.data?.firstName}</span>
                <br />
                <span>मोबाईल क्र. {event?.data?.mobileNumber}</span>
              </div> */}
            <div style={detailsStyle}>
              <span
                style={{
                  color: "white",
                  fontSize: "clamp(20px, 4vw, 28px)",
                  fontWeight: "bold",
                }}
              >
                {selectedEventDetails.date || "NA"}
              </span>

              <div style={qrCodeContainerStyle}>
                {/* <img
                  src={event?.data?.qrCodeLink}
                  alt="QR Code"
                  style={qrCodeStyle}
                /> */}
                <img src={qr} crossOrigin="anonymous" />
              </div>
              {/* <div style={mainContainerStyle}>
                <div style={cardStyle}>
                  <span style={largeTextStyle1}>
                    {event?.data?.gate ? event?.data?.gate : "2A"}
                  </span>
                  <div style={sideTextStyle}>
                    <span style={headerTextStyle}>
                      <>
                        {event?.data?.gate === 3 ? (
                          <>
                            प्रवेशद्वार साउथ पॉइंट स्कूल समोर <br /> हनुमान नगर
                          </>
                        ) : event?.data?.gate === 4 ? (
                          <>प्रवेशद्वार आयुर्वेदिक कॉलेज, रेशिमबाग</>
                        ) : (
                          <>
                            प्रवेशद्वार प्रगती हॉल समोर <br /> हनुमान नगर
                          </>
                        )}
                      </>
                    </span>
                    <span
                      style={{
                        fontSize: "12px",
                        lineheight: "1.0",
                        marginTop: "4px",
                        color: "white",
                        // color:event?.data?.gate ? "white": "#3e1d0a",
                      }}
                    >
                      स्थळ: ईश्वर देशमुख शारीरिक शिक्षण महाविद्यालय, क्रीडा चौक,
                      हनुमान नगर, नागपूर.
                    </span>
                  </div>
                </div>
              </div> */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <span
                  style={{
                    color: "black",
                    fontWeight: "normal",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    color: "white",
                  }}
                >
                  Powered By
                  <img
                    src="/bharatOnline.png"
                    alt="bharatOnline"
                    crossOrigin="anonymous"
                    style={{
                      marginRight: "8px",
                      height: "50px",
                      marginLeft: "6px",
                    }} // Adjust the size as needed
                  />
                  Bharat Online
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* )} */}
    </>
  );
};

export default InvitationCard;
